<template>
  <div :class="classes">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table" :isAddPageToRouter="true"
      :isOutside="isOutside" :refresh="false" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
      <wt-table :list="tableData" :labels="tableLabels">
          <template>
            <slot/>
          </template>
      </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-customer-table'
export default {
  name: 'pt-customer-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
    //   userTableLabels: userTableLabels
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showReTry () {
      this.$refs.table.showReTry()
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('getTableData', page, next, size)
    }
  },
  created () {
    console.log(this.$route)
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
